import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { Redirect } from 'react-router-dom';
import VehicleAddOrUpdate from "./VehicleAddOrUpdate";
import PndRestApi from "src/utils/pnd/PndRestApi";
import { showNotification, successNofication } from "src/shared/components/Notification";
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";
import dayjs from 'dayjs';
import CloseIcon from '@mui/icons-material/Close';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import { CircularProgress } from '@mui/material';

const VehicleModal = ({ modalShow, setModalShow, isTitle, vehicleData }) => {
    const [isRedirect, setIsRedirect] = useState(false);
    const [loading, setLoading] = useState(false);
    const [vehicleRegistrationExpiryDate, setVehicleRegistrationExpiryDate] = useState(
        vehicleData?.vehicleRegistrationExpiryDate ? dayjs(vehicleData?.vehicleRegistrationExpiryDate).format('YYYY-MM-DD') : null
    );

    useEffect(() => {
        if (vehicleData?.vehicleRegistrationExpiryDate) {
            setVehicleRegistrationExpiryDate(dayjs(vehicleData.vehicleRegistrationExpiryDate).format('YYYY-MM-DD'));
        } else {
            setVehicleRegistrationExpiryDate(null);
        }
    }, [vehicleData, modalShow]);

    if (isRedirect) {
        window.location.reload();
        return <Redirect to="/web_app/pnd_vehicle/view" />;
    }

    const toggle = () => {
        if (!loading) {
            setModalShow(prevState => !prevState);
        }
    }

    const handleSubmit = async (formValues) => {
        try {
            let obj = {};
            setLoading(true);
            obj["plateNo"] = formValues["plateNo"];
            obj["vehicleModelInfo"] = {
                vehicleModelId: formValues["vehicleModelInfo"]["value"]
            };
            obj["vehicleTypeInfo"] = {
                vehicleTypeId: formValues["vehicleTypeInfo"]["value"]
            };
            obj["vehicleMakersInfo"] = {
                vehicleMakerId: formValues["vehicleMakersInfo"]["value"]
            };
            obj["vehicleUniqueId"] = formValues["vehicleUniqueId"];

            obj["countryInfo"] = {
                countryId: formValues["countryInfo"]["value"]
            };
            obj["stateInfo"] = {
                stateId: formValues["stateInfo"]["value"]
            };
            if (formValues["hubInfo"]["value"]) {
                obj["hubId"] = formValues["hubInfo"]["value"];
            }
            obj["yearOfManufacture"] = formValues["yearOfManufacture"]["label"];
            formValues["vehicleRegistrationExpiryDate"] = vehicleRegistrationExpiryDate;
            if (formValues["vehicleRegistrationExpiryDate"]) {
                const date = new Date(formValues["vehicleRegistrationExpiryDate"]);
                if (!isNaN(date.getTime())) {
                    obj["vehicleRegistrationExpiryDate"] = date.toISOString();
                }
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: 500`,
                    `Message:Please select vehicle Registration Expiry Date.`,
                );
                setLoading(false);
                return;
            }
            obj["assetName"] = formValues["vehicleModelInfo"]["value"];
            if (formValues["vehicleId"] !== undefined || formValues["vehicleId"] != null) {
                obj["vehicleId"] = formValues["vehicleId"];
            } else {
                obj["vehicleId"] = null;
            }
            obj["status"] = formValues["status"];
            obj["loadCapacity"] = formValues["loadCapacity"];
            const response = await PndRestApi.AddOrUpdateVehicleDetails(obj);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setTimeout(() => {
                    setIsRedirect(true);
                }, PAGE_TIMEOUT);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName="ltr-support"
                className="theme-light ltr-support"
                size="lg"
                backdrop={loading ? "static" : true}
                style={{ maxWidth: '800px' }}
            >
                {/* Modern Modal Header */}
                <div
                    className="position-relative"
                    style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        padding: '1.5rem 2rem',
                        borderRadius: '0.5rem 0.5rem 0 0',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }}
                >
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div
                                className="d-flex align-items-center justify-content-center me-3"
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    background: 'rgba(255,255,255,0.2)',
                                    borderRadius: '12px',
                                    backdropFilter: 'blur(10px)'
                                }}
                            >
                                <DriveEtaIcon style={{ fontSize: '28px', color: '#fff' }} />
                            </div>
                            <div>
                                <h4
                                    className="m-0 text-white fw-bold"
                                    style={{
                                        fontSize: '1.5rem',
                                        letterSpacing: '0.5px',
                                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    {isTitle}
                                </h4>
                                <p className="m-0 text-white-50 small">
                                    {vehicleData ? 'Update vehicle information' : 'Add new vehicle to the system'}
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={toggle}
                            disabled={loading}
                            className="btn-close-custom"
                            style={{
                                background: 'rgba(255,255,255,0.2)',
                                border: 'none',
                                borderRadius: '50%',
                                width: '36px',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                                opacity: loading ? 0.5 : 1
                            }}
                            onMouseEnter={(e) => {
                                if (!loading) {
                                    e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                                    e.currentTarget.style.transform = 'rotate(90deg)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                                e.currentTarget.style.transform = 'rotate(0deg)';
                            }}
                        >
                            <CloseIcon style={{ color: '#fff', fontSize: '20px' }} />
                        </button>
                    </div>
                </div>

                {/* Modal Body */}
                <ModalBody className="p-0" style={{ background: '#f8f9fa' }}>
                    {loading && (
                        <div
                            className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                            style={{
                                background: 'rgba(255,255,255,0.9)',
                                zIndex: 1050,
                                backdropFilter: 'blur(4px)'
                            }}
                        >
                            <div className="text-center">
                                <CircularProgress size={50} style={{ color: '#667eea' }} />
                                <p className="mt-3 text-muted fw-bold">Processing...</p>
                            </div>
                        </div>
                    )}

                    <div style={{ maxHeight: 'calc(90vh - 120px)', overflowY: 'auto' }}>
                        <VehicleAddOrUpdate
                            title="User Details"
                            onSubmit={handleSubmit}
                            vehicleData={vehicleData}
                            status={vehicleData?.status}
                            vehicleRegistrationExpiryDate={vehicleRegistrationExpiryDate}
                            setExpDate={setVehicleRegistrationExpiryDate}
                        />
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default connect((state) => ({
    rtl: state.rtl,
}))(VehicleModal);
